// @ts-nocheck
import { useMemo } from 'react';

const useQuarterTimeLeft = () => {
  return useMemo(() => {
    const now = new Date();
    const month = now.getMonth();
    const quarterStartMonth = Math.floor(month / 3) * 3;
    const start = new Date(now.getFullYear(), quarterStartMonth, 1);
    const end = new Date(start.getFullYear(), start.getMonth() + 3, 0);
    const totalDaysInQuarter = Math.ceil((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));
    const daysPassed = Math.ceil((now.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));
    const daysLeft = totalDaysInQuarter - daysPassed;
    const quarterNumber = Math.floor(month / 3) + 1;
    const dateSpan = `${start.getDate()} ${start.toLocaleString('default', { month: 'long' })} to ${end.getDate()} ${end.toLocaleString('default', { month: 'long' })}`;

    return {
      quarterData: [
        { name: "Days Passed", value: daysPassed },
        { name: "Days Left", value: daysLeft }
      ],
      quarterInfo: `Q${quarterNumber}: ${dateSpan}`
    };
  }, []);
};

export default useQuarterTimeLeft;